import { EProductConditions, ICustomizeTableColumn } from 'types/listsTypes';

export type TMalformedField = 'price' | 'picture' | 'description' | 'inventory'

export interface IProduct {
  id: string;
  imageUrl: string;
  categoryId: string;
  categoryName: string;
  title: string;
  priceFrom: number;
  priceTo: number;
  isActive: boolean;
  inventoryFrom: number;
  inventoryTo: number;
  tags: string[];
  createdAt: string;
  updatedAt: string;
  cognitoUsername: string;
  url: string,
  malformedFields: TMalformedField[],
  collections: { id: string, title: string }[] | undefined,
  productCondition: EProductConditions,
  mapPercent: number | null,
  mapFrom: number | null,
  mapTo: number | null,
}

export const defaultProductsTableSettings: ICustomizeTableColumn[] = [
  { title: '', dataIndex: 'imageUrl', isFixed: true, isChecked: true },
  { title: 'Title', dataIndex: 'title', isFixed: true, isChecked: true },
  { title: '', dataIndex: 'extraActions', isFixed: true, isChecked: true },
  { title: 'Source', dataIndex: 'source', isChecked: true },
  { title: 'Status', dataIndex: 'isActive', isChecked: true },
  { title: 'Category', dataIndex: 'categoryId', isChecked: true },
  { title: 'Inventory', dataIndex: 'inventory', isChecked: true },
  { title: 'Price', dataIndex: 'price', isChecked: true },
  { title: 'MAP', dataIndex: 'map', isChecked: true },
  { title: 'Shopify Collections', dataIndex: 'collections', isChecked: true },
  { title: 'Tags', dataIndex: 'tags', isChecked: true },
  { title: '', dataIndex: 'empty', isChecked: true },
];
